/* React base component */
import { Component } from "react"

/* Translation */
import { translate } from "../translates"

/* Component Network */
class Network extends Component {

    render = () => {
        return (
            <div className="network">
                <div className="network__icon">
                    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M12 9v4M12 17h.01" />
                        <circle cx="12" cy="12" r="9" />
                    </svg>
                </div>
                <h3 className="network__title">{this.props.title || translate("Что-то пошло не так")}</h3>
                <p className="network__text">{this.props.text || translate("Проверьте соединение и попробуйте снова.")}</p>
                {this.props.onRetry && (
                    <button className="network__retry" onClick={this.props.onRetry}>{translate("Повторить")}</button>
                )}
            </div>
        )
    }
}

/* Export */
export default Network
